module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgements"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Maps"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Map")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter_1"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 1")]), _vm._v(" General Władysław Anders, Origins and the Polish Army, 1892–1939")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter_2"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 2")]), _vm._v(" 1939–1941: The Division of Poland and Relations with the Soviet Union")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 3")]), _vm._v(" Amnesty and Evacuation")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 4")]), _vm._v(" The Formation of Second Polish Corps")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 5")]), _vm._v(" Anders and Sikorski, 1942–1943")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 6")]), _vm._v(" Italy and Monte Cassino")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 7")]), _vm._v(" Italy after Monte Cassino")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 8")]), _vm._v(" 1945–1948: A New Poland and a Divided Europe")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 9")]), _vm._v(" Europe and Poland: Immediate Post-War Problems")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 10")]), _vm._v(" The End: 1947–1970")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Endnotes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0